import React, { FC, useState } from 'react'
import { useSnackbar } from 'notistack'
import { connect } from 'react-redux'
import { StateType } from '../../../redux/store'
import { EnqueueSnackbarType, showMessage } from '../../common/Helpers'
import DtoolRelationUIBox from './DtoolRelationUIBox'
import { addDtoolRelation } from '../../../redux/appReducer'
import { DtoolRelationPropsType, MaterialType, MaterialGroupType, HardwareType } from '../../../api/appAPI'

interface IProps {
  hardwares: HardwareType[]
  materials: MaterialType[]
  materialGroups: MaterialGroupType[]
  addDtoolRelation(relation: DtoolRelationPropsType, enqueueSnackbar: EnqueueSnackbarType): void
}

const DefineDtoolRelation: FC<IProps> = (props) => {
  const { enqueueSnackbar } = useSnackbar()

  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [type, setType] = useState<'hardware' | 'material' | 'materialGroup'>('hardware')
  const [tags, setTags] = useState<string[]>([])
  const [targetId, setTargetId] = useState<number | ''>('')

  const handleCreateClick = () => {
    if (!name.trim()) {
      showMessage(enqueueSnackbar, 'Enter relation name')
      return
    }
    if (!targetId) {
      showMessage(enqueueSnackbar, 'Select a target')
      return
    }

    props.addDtoolRelation(
      {
        name,
        description,
        type,
        tags,
        targetId: targetId as number,
      },
      enqueueSnackbar
    )

    setName('')
    setDescription('')
    setType('hardware')
    setTags([])
    setTargetId('')
  }

  return (
    <DtoolRelationUIBox
      title="New Dtool Relation"
      name={{ value: name, onChange: (e) => setName(e.target.value) }}
      description={{ value: description, onChange: (e) => setDescription(e.target.value) }}
      type={{
        value: type,
        onChange: (e) => {
          setType(e.target.value as any)
          setTargetId('')
        },
      }}
      tags={{ value: tags, onChange: setTags }}
      targetId={{ value: targetId as number, onChange: (e) => setTargetId(e.target.value as number) }}
      hardwares={props.hardwares}
      materials={props.materials}
      materialGroups={props.materialGroups}
      onButtonClick={handleCreateClick}
    />
  )
}

const mapStateToProps = (state: StateType) => ({
  hardwares: state.itemReducer.hardwaresList,
  materials: state.itemReducer.materials,
  materialGroups: state.itemReducer.materialGroups,
})

export default connect(mapStateToProps, { addDtoolRelation })(DefineDtoolRelation)
